import { DashboardContentStyled } from "./styled";

import { IFunctionalComponentProps } from "@/types/functional-component";

const DashboardContent: React.FC<IFunctionalComponentProps> = ({ children }) => {
    return <DashboardContentStyled>{children}</DashboardContentStyled>;
};

export default DashboardContent;
